import './sectionCareersCards.scss';

export default (() => {
	if ($('.section--careers-cards').length > 0 && $('.section--careers-cards .button--green').length > 0) {
		if (current_page === max_page) $('.section--careers-cards .button--green').css('display', 'none');
		document.querySelector('.section--careers-cards .button--green').onclick = function (e) {
			const container = document.querySelector('.section--careers-cards .row');
			e.preventDefault();
			var careersData = {
				action: 'loadmore_careers',
				query: careersQuery,
				page: current_page,
				maxPage: max_page
			};
			if (current_page > 0) {
				$.ajax({
					url: ajaxurl,
					data: careersData,
					type: 'POST',
					beforeSend: function (xhr) {
						$(e.target).attr('disabled');
					},
					success: function (data) {
						if (data) {
							$(container).append(data);
							current_page++;
							$(e.target).removeAttr('disabled');
							if (current_page === careersData.maxPage) $(e.target).css('display', 'none');
						}
					}
				});
			}
		};
	}
})();
